module.exports = __webpack_public_path__ + "static/media/quotation.281902a8.svg";